// お客様に見える文言は全部ここ。
//
// **文言は最終確定ではない。** 予約購入まわりは過去に竹内さんが確定した経緯があり、
// 後から調整が入る前提。触るときはこのファイルだけで済むようにしてある。
//
// 土台は page/2510（在庫不足の前身フォーム）の原文。見出し・項目名・エラー文言は
// 人の手が入って落ち着いているので、意図が無ければ変えない。
//
// ★「確保」「お取り置き」と読める表現を使わないこと。
//   **予約注文でも在庫は減らない**（ChatBan #38 の決定）。書くと実態と食い違う。
// ★**納期を書かないこと**（2026-08-07 竹内さん判断。個別対応が望ましいため）。
//   「ご予約の案内を別途いたします」は次に何が起きるかだけを言っていて納期に触れていない。この線を越えない。

export const TEXT = {
  // 入口の3択カード（Issue #20。ES さんが page/2524 に作った HTML の文言そのまま）。
  // 旧入口のボタン「ご希望の数量が在庫を上回る場合はこちら」はこれに置き換えた。
  // 文言は ES さんが持っているので、後で差し替えが入る前提。
  // ★カード②の「入荷次第、順次発送いたします」は元のまま可（確保・お取り置きとは読めない）。
  cards: {
    title: 'ご注文方法のご案内',
    pill: '分納での発送は承っておりません',
    /** ① フォーム不要。そのまま買ってもらう（押しても何も登録しない） */
    stock: {
      head: '在庫表示分だけ<br>納品希望の方（即納）',
      figLabel: '在庫がある分だけをカートに入れる',
      desc: '在庫がある分だけを<br>カートに入れて<br>そのままご注文ください。',
      /** 在庫数の下に出す、商品ページへの戻り。②③の「▶ このフォームで登録」と同じ体裁（2026-09-10 田口さん指示） */
      back: '▶ 購入ページへ',
    },
    /** ② 種別1（予約注文）でフォームを開く */
    reserve: {
      head: '全数まとめて納品<br>ご希望の方（予約）',
      pickLabel: '全数まとめて納品ご希望の方（予約）を選ぶ',
      figLabel: '予約注文',
      figText: '予約注文',
      desc: '在庫以上の数量が必要な場合は<br>予約注文をご利用ください。<br>入荷次第、順次発送いたします。',
    },
    /** ③ 種別2（入荷通知）でフォームを開く */
    notify: {
      head: '入荷通知連絡のみ<br>ご希望の方',
      pickLabel: '入荷通知連絡のみご希望の方を選ぶ',
      figLabel: '入荷時にメールでご連絡',
      desc: '入荷時にメールで<br>ご連絡します。<br>すぐに注文しない方は<br>ご利用ください。',
    },
    warnLabel: '注意',
    warn: '在庫以上の数量をカートに入れると、自動でキャンセルとなりますのでご注意ください。',
    /** ②③カードの下部に出す「押せる」合図（Issue #24）。仮文言。後で差し替えが入る前提 */
    pickHint: '▶ このフォームで登録',
  },

  // ★ここは「選べる」ように書かない。**分けて発送できない**という制約が先に来る。
  //   旧文は「在庫のある分は、そのままご購入いただけます」で、在庫分だけ先に送って
  //   残りを後から、と期待させる書き方だった（実際はできない）。
  lead: {
    title: '【ご希望の数量が在庫を上回っています】',
    intro: '1回のご注文を分けてお届けすることはできません。次のいずれかをお選びください。',
    cases: [
      {
        head: '在庫のある分だけ先に必要な場合',
        body: '数量を在庫数に変更して、そのままご注文ください。',
      },
      {
        head: 'ご希望の数量をまとめて必要な場合',
        body: '「予約する」をお選びください。ご予約の案内を別途いたします。',
        // ★この一文は**予約購入ページに焼き付いている文言と同じ言い回し**
        //   （OppSiteCore2/Services/CustomVariationProductsService.cs:352）。
        //   フォーム → 案内 → 予約購入ページ と同じ文が続いて一貫するので、言い換えないこと。
        note:
          'ご予約は、商品のご用意前にご注文・お支払いをお願いする形になります。' +
          'ご注文後のキャンセル・数量の変更はお受けできません。',
      },
      {
        head: '入荷の時期だけ知りたい場合',
        body: '「入荷したら知らせてほしい」をお選びください。',
      },
    ],
  },

  // 表示在庫が引けたときだけ、選択肢1の下に静かに足す一行（ChatBan #47）。
  // 出す数字は商品ページの在庫表示（.stockInfo）と同じ「表示用に丸めた在庫」。
  // ★引けない商品は普通にあるので、「確認中」のような後から出てくる期待を
  //   持たせる文言をここに増やさないこと。
  stockLine: (num: number, unit: string): string => `現在の在庫数：${num.toLocaleString('ja-JP')}${unit}`,

  section: { wish: 'ご希望内容', customer: 'お客様情報' },

  label: {
    kind: 'ご希望',
    kindReserve: '予約する',
    // ★**ラジオは「何を頼むのか」、リード文は「選ぶとどうなるか」**で役割を分ける。
    //   両方に「ご予約の案内を別途いたします」を書くと同じ念押しが2回出て重複する。
    //   短い対比にしてあるのは、**ラジオだけ見て選ぶ人にも違いが伝わる**ようにするため。
    kindReserveNote: '不足分もまとめて手配',
    kindNotify: '入荷したら知らせてほしい',
    kindNotifyNote: '通知のみ',
    product: '商品名',
    quantity: 'ご希望数量',
    quantityOptional: 'ご希望数量（お決まりであれば）',
    note: '備考',
    name: 'お名前',
    company: '会社名',
    email: 'メールアドレス',
    tel: '電話番号',
    required: '＊必須',
  },

  placeholder: {
    quantity: '例：5000',
    note: 'ご希望の時期・その他ご要望など',
    email: 'example@example.com',
    tel: '03-1234-5678',
  },

  submit: '送信する',
  submitting: '送信中…',

  error: {
    kind: '「ご希望」をお選びください。',
    quantity: '「ご希望数量」をご入力ください。',
    quantityPositive: '「ご希望数量」は1以上の数でご入力ください。',
    /** Issue #18。上限は shared/stock-shortage-limits.ts の QUANTITY_MAX（サーバーと同じ値） */
    quantityMax: (max: string) => `「ご希望数量」は${max}までご入力いただけます。それ以上をご希望の場合はお問い合わせください。`,
    name: '「お名前」をご入力ください。',
    email: '「メールアドレス」を正しくご入力ください。',
    failed: '送信に失敗しました。お手数ですが時間をおいて再度お試しください。',
    network: '送信に失敗しました。通信環境をご確認のうえ、再度お試しください。',
  },

  // 控えメールは Core2 が後から拾って送る（即時ではない）。
  // ★「数分以内」と約束しないこと。2510 は「通常数分以内に自動送信」と書いていたが、
  //   こちらの経路では送信タイミングを保証できない。
  // 完了枠（2026-09-22 田口さん要望: 消えるだけでなく「送信完了」とはっきり出す。全店共通）
  doneTitle: '送信完了',
  done:
    '送信を受け付けました。ありがとうございます。担当者より折り返しご連絡いたします（通常1営業日以内）。',
  doneMail: '※ご入力のメールアドレスへ、受付確認（控え）メールをお送りします。',
  doneSummary: '受け付けた内容',
  doneQuantityNone: '（未記入）',

  note: '※送信後、担当者より折り返しご連絡いたします。通常1営業日以内にご返信します。',
} as const
